export var NAMESPACE = '1b671a64-40d5-491e-99b0-da01ff1f3341';
export var SCRIPT_ATTR_ALLOWED = ['async', 'defer', 'crossorigin', 'fetchpriority', 'integrity', 'nonce', 'nomodule', 'referrerpolicy'];